module.exports = __webpack_public_path__ + "32902eec542d3ab618d0af4a10da8c00.svg";